import React from 'react';
import MarkdownDocPage from '../MarkdownDocPage';

export default function UserManualWorkbenchPage() {
    return <MarkdownDocPage title="Workbench" markdownUrl="/docs/user-manual/pages/workbench.md" />;
}

